import { useState } from "react";
import { useNavigate } from "react-router-dom";
import Card from "@mui/material/Card";
import MDBox from "components/MDBox";
import MDTypography from "components/MDTypography";
import MDInput from "components/MDInput";
import MDButton from "components/MDButton";
import MDSnackbar from "components/MDSnackbar";
import Cookies from "js-cookie";
import BasicLayout from "layouts/authentication/components/BasicLayout";
import bgImage from "assets/images/bg.jpg";
import { useLogin } from "api/useApi.ts";

function Basic() {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);
  const [notification, setNotification] = useState({
    open: false,
    message: "",
    severity: "success",
  });

  const navigate = useNavigate();

  const handleCloseNotification = () => {
    setNotification((prevState) => ({ ...prevState, open: false }));
  };

  const loginMutation = useLogin();

  const handleSignIn = async () => {
    try {
      const response = await loginMutation.mutateAsync({
        email,
        password,
      });
      const { token, data } = response;
      Cookies.set("authToken", token, { expires: 7 });
      Cookies.set("userData", JSON.stringify(data.user), { expires: 7 });

      setLoading(false);
      setNotification({
        open: true,
        message: "Sign in successful! Redirecting to dashboard...",
        severity: "success",
      });

      // Redirect to dashboard after 2 seconds
      setTimeout(() => {
        navigate("/tables", { replace: true });
      }, 2000);
    } catch (error) {
      setLoading(false);
      setNotification({
        open: true,
        message: error.response?.data?.message || "Sign in failed. Please check your credentials.",
        severity: "error",
      });
    }
  };

  return (
    <BasicLayout image={bgImage}> 
      <Card>
        <MDBox
          variant="gradient"
          bgColor="info"
          borderRadius="lg"
          coloredShadow="info"
          mx={2}
          mt={-3}
          p={2}
          mb={1}
          textAlign="center"
        >
          <MDTypography variant="h4" fontWeight="medium" color="white" mt={1}>
            Sign in
          </MDTypography>
        </MDBox>
        <MDBox pt={4} pb={3} px={3}>
          <MDBox component="form" role="form">
            <MDBox mb={2}>
              <MDInput
                type="email"
                label="Email"
                fullWidth
                value={email}
                onChange={(e) => setEmail(e.target.value)}
              />
            </MDBox>
            <MDBox mb={2}>
              <MDInput
                type="password"
                label="Password"
                fullWidth
                value={password}
                onChange={(e) => setPassword(e.target.value)}
              />
            </MDBox>
            <MDBox mt={4} mb={1}>
              <MDButton
                variant="gradient"
                color="info"
                fullWidth
                onClick={handleSignIn}
                disabled={loading}
              >
                {loading ? "Signing in..." : "Sign in"}
              </MDButton>
            </MDBox>
          </MDBox>
        </MDBox>
      </Card>

      {/* Notification Snackbar */}
      <MDSnackbar
        color={notification.severity}
        icon={notification.severity === "success" ? "check" : "error"}
        title={notification.severity === "success" ? "Success" : "Error"}
        content={notification.message}
        open={notification.open}
        onClose={handleCloseNotification}
        close={handleCloseNotification}
        bgWhite
      />
    </BasicLayout>
  );
}

export default Basic;
